import React from 'react';

export default function SimpleAlert({ open, message, onClose, onConfirm, title = '重庆章网印章业务授权管理系统提示您：' }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0,
      bottom: 0,
      width: '100%', 
      height: '100%',
      background: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      zIndex: 9999,
      margin: 0,
      padding: 0
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: '20px 24px 40px 24px',
        minWidth: 300,
        maxWidth: '90%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        position: 'relative',
        margin: 'auto'
      }}>
        {/* 标题 */}
        <div style={{
          marginBottom: 16,
          fontSize: 16,
          fontWeight: 600,
          color: '#ff0000'
        }}>{title}</div>

        {/* 消息内容 */}
        <div style={{ 
          marginBottom: 32, 
          fontSize: 18, 
          color: '#333', 
          wordBreak: 'break-all',
          lineHeight: '1.5',
          whiteSpace: 'pre-line'
        }}>
          {message}
        </div>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          {/* 取消按钮：仅在提供 onConfirm 时显示，用于确认对话框 */}
          {typeof onConfirm === 'function' && (
            <button
              onClick={onClose}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: 14,
                cursor: 'pointer',
                fontWeight: '500',
                minWidth: 80
              }}
            >
              取消
            </button>
          )}

          <button
            onClick={() => {
              if (typeof onConfirm === 'function') onConfirm();
              onClose();
            }}
            style={{
              background: '#2d8cf0',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '12px 24px',
              fontSize: 14,
              cursor: 'pointer',
              fontWeight: '500',
              minWidth: 80
            }}
          >
            确定
          </button>
        </div>
      </div>
    </div>
  );
} 